<template>
  <div class="container">
    <head-top />
    <div class="content">
      <!-- 面包屑 -->
      <div class="nav">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/index' }">{{ $t('navbar.home') }}</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/exhibition' }">{{ $t('navbar.exhibition') }} </el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('exhibition.detailTitle') }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 公司介绍 -->
      <div class="active_detail">
        <div class="active_img">
          <div class="img_box">
            <img :src=" exForm.comCover" alt="" />
          </div>

          <div class="option">
            <div class="vr" @click="routerLink('vr')">
              <img alt="" src="../../static/btn-VR-yellow.png" />
              <span>{{ $t('navbar.VRview') }}</span>
              <ul v-if="boothNmu.length > 1">
                <li v-for="(ite, index) in boothNmu" :key="index">
                  {{ $t('exhibition.go') }}{{ ite.boothNum }}
                  {{ $t('exhibition.place') }}
                </li>
              </ul>
            </div>
            <div class="picture" @click="routerLink('imgView')">
              <img alt="" src="../../static/btn_picture.png" />
              <span>{{ $t('navbar.imgView') }}</span>
              <ul v-if="boothNmu.length > 1">
                <li v-for="(ite, index) in boothNmu" :key="index">
                  {{ $t('exhibition.go') }}{{ ite.boothNum }}
                  {{ $t('exhibition.place') }}
                </li>
              </ul>
            </div>
            <div class="vedio" @click="routerLink('videoView')">
              <img alt="" src="../../static/btn-vedio.png" />
              <span>{{ $t('navbar.videoView') }}</span>
              <ul v-if="boothNmu.length > 1">
                <li v-for="(ite, index) in boothNmu" :key="index">
                  {{ $t('exhibition.go') }}{{ ite.boothNum }}
                  {{ $t('exhibition.place') }}
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="active_content">
          <p class="title" @mouseenter="openDiag()">
            {{ exForm.v_companyName }}
          </p>

          <div class="active_time">
            <div class="all_time">
              <!--展商的展位号不一定会有多个  -->
              <div v-for="(item, index) in boothNmu" :key="index" class="time">
                <p>
                  {{ $t('common.boothNum1') }}<span>{{ item.boothNum }}</span>
                  <!-- <img src="../../static/btn-VR.png" /> -->
                </p>
                <p>{{ $t('exhibition.boothArea') }}{{ item.boothArea }}㎡</p>
              </div>
              <p style="margin-top: 20px">{{ $t('exhibition.companyNature') }}{{ exForm.enteProperty }}</p>
            </div>

            <!--鼠标悬停展商详情页面展出  -->
            <div v-if="exhiflag" class="exhidetail">
              <div class="close" @click="close">
                <img src="../../static/close.png" :alt="$t('common.close')" />
              </div>

              <div class="img_box">
                <img alt="" :src=" exForm.column16" />
              </div>
              <div class="address">
                <div class="address_detail">
                  <p>{{ $t('exhibition.companyAddress') }}</p>
                  <p :title="exForm.addressC">{{ exForm.address }}</p>
                </div>
                <div class="address_detail">
                  <p>{{ $t('exhibition.companyWebsite') }}</p>
                  <p :title="exForm.comUrl" class="jumping" @click="jumping(exForm.comUrl)">
                    {{ exForm.comUrl }}
                  </p>
                </div>
                <div class="address_detail">
                  <p>{{ $t('exhibition.companyPhone') }}</p>
                  <p :title="exForm.telephone">{{ exForm.telephone }}</p>
                </div>
                <div class="address_detail">
                  <p>{{ $t('exhibition.companyEmail') }}</p>
                  <p :title="exForm.email">{{ exForm.email }}</p>
                </div>
              </div>
            </div>
          </div>
          <!-- 咨询展商按钮 -->
          <div class="collent_btn">
            <button class="shoucang" @click="consult(exForm)">
              {{ $t('common.consult') }}
            </button>

            <button v-if="exForm.collectStatus" class="shoucang3" @click="collectexh">
              {{ $t('common.collected') }}
            </button>

            <button v-else class="shoucang2" @click="collectexh">
              {{ $t('common.collectExhibition') }}
            </button>

            <button class="lastbutton" @click="sendCards()" :style="{ width: lang == 'zh' ? '145px' : '' }">
              {{ $t('exhibition.sendCard') }}
            </button>
          </div>
        </div>
      </div>
      <!-- 展商介绍 -->
      <div class="exhitbi_inc" v-if="exForm.column17 || exForm.column25">
        <h3 :style="{ width: lang == 'zh' ? '152px' : '270px' }">
          {{ $t('exhibition.exhibitionIntroduce') }}
        </h3>
        <p v-html="exForm.v_introduce" class="content"></p>
        <!-- 视频播放 -->
        <div class="vedio" v-if="exForm.column25">
          <video class="shipin" controls="controls" :src=" exForm.column25" :poster="exForm.column23">
            your browser does not support the video tag
          </video>
        </div>
      </div>

      <!-- 产品中心 -->
      <div class="product" v-if="showExhibits">
        <h3 :style="{ width: lang == 'zh' ? '152px' : '270px' }">
          {{ $t('exhibition.productCenter') }}
        </h3>
        <div class="product_box">
          <div class="list">
            <p>{{ $t('exhibition.productSeries') }}</p>
            <!-- <p class="all" @click="changeProduct">全部产品</p> -->
            <ul>
              <li
                v-for="(item, index) in navImg"
                :key="index"
                :class="{ allClick: index === selProdu }"
                class="leftItem"
                @click="changeProduct(item, index)"
                :title="item.name"
              >
                {{ item.name }}
              </li>
            </ul>
          </div>
          <div class="right">
            <div v-for="(item, index) in RecommendExhibits" :key="index" class="rightBox" @click.stop="routePro(item)">
              <div class="parameter">
                <div class="titl">{{ item.exhibitsName }}</div>
                <div class="english">{{ item.seriesName }}</div>
                <div class="txt">{{ item.column17 }}</div>
              </div>
              <div class="backImg">
                <img :src="item.exhibitsCoverImg" alt="" v-if="item.exhibitsCoverImg.substr(0,4)=='http'"/>
                <img :src="baseUrl + item.exhibitsCoverImg" alt="" v-else/>
              </div>
              <div class="boxBottom">
                <span class="bottomTxt"
                  ><a href="#">{{ $t('common.more') }}</a></span
                >
                <img
                  :src="item.collectStatus ? require('../../static/collent_yello.png') : require('../../static/collen1t.png')"
                  class="bottomImg"
                  @click.stop="collectPro(item)"
                />
              </div>
            </div>
            <div v-if="morePro" class="more" @click="getMorePro()">{{ $t('exhibition.openMore') }}<span class="icon_more"></span></div>
          </div>
        </div>
      </div>

      <!-- 展商直播 -->
      <div class="live" v-if="live.length >= 1">
        <h3 :style="{ width: lang == 'zh' ? '152px' : '270px' }">
          {{ $t('exhibition.live') }}
        </h3>
        <div class="live_zhibo">
          <div class="live-box">
            <div v-for="(item, index) in live" :key="index" class="item" @click="routeLive(item)">
              <div class="vedio">
                <img
                  :src="item.collectStatus ? require('../../static/collent_yello.png') : require('../../static/collent.png')"
                  class="shoucang"
                  @click.stop="collectLive(item)"
                />
                <img :src="item.coverPhoto" alt="" class="zhibopic" />
                <div class="fixed">
                  <div class="banner-btn">
                    <img alt="" src="../../static/ico_vedio.png" />
                  </div>
                </div>
              </div>
              <div class="title">
                <p>{{ item.liveCn }}</p>
                <p class="ptime">
                  <img alt="" src="../../static/ico-time.png" />
                  {{ item.startDate }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 展商活动 -->
      <div class="exhibitor_active" v-if="showactives">
        <h3 :style="{ width: lang == 'zh' ? '152px' : '270px' }">
          {{ $t('exhibition.activity') }}
        </h3>
        <div class="active_box">
          <div class="list">
            <p>{{ $t('exhibition.activityType') }}</p>
            <ul>
              <li
                v-for="(item, index) in active_live"
                :key="index"
                :class="{ allClick: index === selActive }"
                class="leftItem"
                @click="changeActive(item, index)"
                :title="item.name"
              >
                {{ item.label }}
              </li>
            </ul>
          </div>
          <div class="right">
            <div v-for="(item, index) in activeData" :key="index" class="item" @click="activeDetail(item)">
              <div class="vedio">
                <img
                  :src="item.collectStatus ? require('../../static/collent_yello.png') : require('../../static/collent.png')"
                  alt=""
                  class="shoucang"
                  @click.stop="collectActve(item)"
                />
                <img :src="item.column15" class="vedio_picture" />
              </div>
              <div class="title">
                <p>{{ item.actTitle }}</p>
                <p class="acttime" style="color: #666666; font-size: 16px">
                  <span><img align="absmiddle" src="../../static/ico_time.png"/></span>
                  {{ item.startTime }}
                </p>
                <p class="zhanwei">
                  <span><img align="absmiddle" src="../../static/ico_address.png"/></span>
                  {{ $t('exhibition.boothNum') }}
                  <span style="color: #666666; font-size: 16px">{{ item.hzBoothList[0].boothNum }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 展商新闻 -->
      <div class="exhibitor_news" v-if="exhibNews.length >= 1">
        <h3 :style="{ width: lang == 'zh' ? '152px' : '270px' }">
          {{ $t('exhibition.news') }}
        </h3>
        <div v-for="(item, index) in exhibNews" :key="index" class="news_box" @click="routerNews(item)">
          <div class="news_pricture">
            <img :src=" item.coverPhoto" alt="" v-if="item.coverPhoto" />
            <img src="../../static/newsStatic.png" alt="" v-else />
          </div>
          <div class="news_content">
            <p class="title">{{ item.newsTitle }}</p>
            <p class="content1">
              {{ item.abstracts }}
            </p>
            <p class="daytime content1">
              {{ item.createDate }}
            </p>
          </div>
        </div>
      </div>
      <!-- 展商资料 -->
      <div class="exhib_data">
        <h3 :style="{ width: lang == 'zh' ? '152px' : '330px' }">
          {{ $t('exhibition.informations') }}
        </h3>
        <el-table
          :cell-style="{ 'padding-left': '31px', 'font-size': '16px' }"
          :data="tableData"
          :header-cell-style="{
            background: '#FDD000',
            color: '#333333',
            'padding-left': '31px',
            'font-size': '16px',
          }"
          style="width: 100%"
        >
          <el-table-column :label="$t('exhibition.infoName')" prop="informationName" width="900"> </el-table-column>
          <el-table-column :label="$t('exhibition.infoSize')" prop="size" width="180"> </el-table-column>
          <el-table-column :label="$t('common.options')">
            <template slot-scope="scope">
              <p class="buttonText" style="text-decoration: none; color: #006fb8" ref="dowond" @click="download(scope.row.url)">
                {{ $t('common.download') }}
              </p>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <foot-bottom />
  </div>
</template>

<script>
import headTop from '../../common/head.vue';
import footBottom from '../../common/footBottom.vue';
import { forMat, testDomain } from '../../../utils/common';
import * as tools from '../../../utils/roulink';
import { audienceLogin } from '../../../utils/roulink';
import {
  getexhibit,
  getProduct,
  getProSeries,
  getLive,
  getActiveSeries,
  getActive,
  getNews,
  getFormation,
  getShoucang,
  sendCards,
} from '../../../api/exhibitor';

export default {
  data() {
    return {
      baseUrl: forMat(),
      audienLogin: audienceLogin(),
      testBaseDomain: testDomain(),
      collent_toggle: false, //判断是否收藏
      exhiflag: false, //控制鼠标悬停显示公司介绍
      // 展商展位号
      boothNmu: [
        {
          bothNum: 'E3222',
          bothArea: '12m²',
        },
        {
          bothNum: 'W1222',
          bothArea: '24m²',
        },
      ],
      //左边全部产品系列
      navImg: ['系列化煤矿用液压锚杆钻车', '煤矿用巷道修复机', '岩巷掘进装备', '煤矿用切顶钻车', '掘锚机'],
      //产品卡片
      RecommendExhibits: [],
      live: [],
      //活动列表
      active_live: [],
      //展商活动
      activeData: [],
      //展商新闻
      exhibNews: [],
      //展商资料
      tableData: [],
      id: this.$route.query.id,
      // 展商信息
      exForm: {},
      selProdu: 0, //产品系列选中样式
      selActive: 0, //活动系列选中样式
      morePro: false,
      showExhibits: false, //是否显示产品中心
      showactives: false, //是否显示展商活动
      currentPage: '', //加载更多 当前发生的页数
      count: '', //总条数

      //递名片功能的参数
      sendCardsData: {
        hzIdL: '1', //展商ID   -----
        auId: '2', //观众ID   -----
        auName: '3', //观众姓名    -----
        auCompany: '4', //观众单位 -----
        auDept: '5', //观众部门 -----
        auDuty: '6', //观众职务 -----
        auPhone: '7', //观众手机号 -----
        auEmail: '8', //观众email -----
        auCall: '9', //观众称呼【先生，女士】	 -----
      },
    };
  },

  components: {
    headTop,
    footBottom,
  },
  created() {
    window.scrollTo(0, 0);
    this.getexhibition();
    this.getProduSer();
    this.getProdu();
    this.getexhiLive();
    this.getexActive();
    this.getNewsinfo();
    this.getFormations();
    setTimeout(() => {
      this.RecommendExhibits.length >= 1 ? (this.showExhibits = true) : (this.showExhibits = false);
      this.activeData.length >= 1 ? (this.showactives = true) : (this.showactives = false);
    }, 1000);
    this.lang = localStorage.getItem('lang');
  },
  computed: {},
  methods: {
    //下载展商文件
    download(url) {
      const isToken = localStorage.getItem('viewToken'); //观众
      const zsToken = localStorage.getItem('token'); //展商
      if (isToken != '' && isToken != null) {
        let fileUrl = this.baseUrl + url;
        // let a =this.$refs.dowond;
        // window.open(fileUrl);
        let a = document.createElement('a');
        a.setAttribute('download', '');
        a.setAttribute('href', fileUrl);
        a.setAttribute('target', 'view——window');
        a.click();
        a.remove(); //this is ugly but useful!!!
      } else {
        this.$message({
          showClose: true,
          message: this.$t('exhibition.tip1'),
          type: 'error',
        });
      }
    },

    // 展商信息
    async getexhibition() {
      const data = await getexhibit({ id: this.id });
      this.boothNmu = data.data.data.hzBoothList;
      this.exForm = data.data.data;
      // 公司名
      this.exForm.v_companyName = this.exForm.companyNameC;
      if (this.lang == 'en' && this.exForm.companyNameE) {
        this.exForm.v_companyName = this.exForm.companyNameE;
      }
      console.log(this.exForm.v_companyName);
      // 公司简介，英文环境下优先显示英文
      this.exForm.v_introduce = this.exForm.column17;
      if (this.lang == 'en' && this.exForm.column18) {
        this.exForm.v_introduce = this.exForm.column18;
      }
       // 公司简介，英文环境下优先显示英文
       this.exForm.address = this.exForm.addressC;
      if (this.lang == 'en') {
        this.exForm.address = this.exForm.addressE;
      }
      if(this.exForm.comCover.indexOf("http")  == -1){
           this.exForm.comCover= forMat() + this.exForm.comCover;
      }
      if(this.exForm.column16.indexOf("http")  == -1){
           this.exForm.column16= forMat() + this.exForm.column16;
      }

      if(this.exForm.column25.indexOf("http")  == -1){
           this.exForm.column25= forMat() + this.exForm.column25;
      }
      if(this.exForm.column23.indexOf("http")  == -1){
           this.exForm.column23= forMat() + this.exForm.column23;
      }

    },
    // 收藏展商
    async collectexh() {
      // this.exForm.collectStatus = !this.exForm.collectStatus;
      const shouDetail = {
        objId: this.id,
        flag: !this.exForm.collectStatus,
        type: 1,
      };
      try {
        const { data } = await getShoucang(shouDetail);
        if (data.code === 200) {
          this.exForm.collectStatus = !this.exForm.collectStatus;
          const toggleStatus = this.exForm.collectStatus === true ? true : false;
          if (toggleStatus === true) {
            this.$message({
              showClose: true,
              message: this.$t('common.successCollect'),
              type: 'success',
            });
          } else {
            this.$message({
              showClose: true,
              message: this.$t('common.cancelCollect'),
              type: 'error',
            });
          }
        } else {
          tools.login(3);
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 获取产品系列
    async getProduSer() {
      const data = await getProSeries({ exhibitorId: this.id });
      this.navImg = data.data.data;
      this.navImg.unshift({ name: this.$t('exhibition.allProducts') });
    },
    // 获取产品列表
    async getProdu(val) {
      const prams = {
        exhibitorId: this.id,
        seriesId: val,
        pageNo: '1',
        pageSize: '9',
      };
      const { data } = await getProduct(prams);
      // console.log("产品列表得数据", data);
      this.RecommendExhibits = data.data.list;
      this.RecommendExhibits.forEach((item, i) => {
          if(!item.exhibitsCoverImg.includes("http")){
            this.RecommendExhibits[i].exhibitsCoverImg= `${this.baseUrl}${this.RecommendExhibits[i].exhibitsCoverImg}`;
          }
      })

      this.count = data.data.count;
      this.currentPage = data.data.pageNo;
      if (data.data.count > 9) {
        this.morePro = true;
      }
    },
    // 点击产品系列切换
    changeProduct(val, index) {
      this.selProdu = index;
      if (val.name === this.$t('exhibition.allProducts')) {
        this.getProdu();
      } else {
        this.getProdu(val.id);
      }
    },
    // 跳转产品详情
    routePro(val) {
      this.$router.push({
        name: 'exhibItem_detail',
        query: {
          id: val.id,
        },
      });
    },
    // 展开更多
    async getMorePro() {
      // this.morePro = false;
      let count = this.count;
      let page = Math.ceil(count / 9);
      //  console.log(page);
      if (this.currentPage == page) {
        this.morePro = false;
      } else {
        // this.currentPage=this.currentPage+1;
        let pageno = this.currentPage + 1;
        // console.log("当前页面",pageno);
        const prams = {
          exhibitorId: this.id,
          seriesId: '',
          pageNo: pageno,
          pageSize: '9',
        };
        const { data } = await getProduct(prams);
        // console.log("产品中心得数据", data);
        this.currentPage = data.data.pageNo;
        data.data.list.map((item) => {

          if(item.exhibitsCoverImg.indexOf("http")  == -1){
            item.exhibitsCoverImg= forMat() +  item.exhibitsCoverImg;
          }

          this.RecommendExhibits.push({
            id: item.id,
            exhibitsName: item.exhibitsName,
            seriesName: item.seriesName,
            column17: item.column17,
            exhibitsCoverImg: item.exhibitsCoverImg,
            collectStatus: item.collectStatus,
          });
        });
      }
    },
    // 获取直播列表
    async getexhiLive() {
      const data = await getLive({ exhibitorId: this.id });
      this.live = data.data.data;
       this.live.forEach((item, i) => {
          if(item.coverPhoto.indexOf("http")  == -1){
            this.live[i].coverPhoto= forMat() +   this.live[i].coverPhoto;
          }
        })

      // console.log(this.live)
    },
    // 跳转直播详情
    routeLive(val) {
      this.$router.push({
        name: 'live_detail',
        query: {
          userId: val.id,
        },
      });
    },
    // 获取活动
    async getexActive(val) {
      const data1 = await getActiveSeries();
      const data = await getActive({
        exhibitorId: this.id,
        activeType: val,
      });
      if (data1.data.data.length > 0) {
        this.active_live = data1.data.data;
        this.active_live.unshift({ label: this.$t('exhibition.allActivity') });
      }
      this.activeData = data.data.data;

      this.activeData.forEach((item, i) => {
          if(item.column15.indexOf("http")  == -1){
            this.activeData[i].column15= forMat() +   this.activeData[i].column15;
          }
      })

      


      // console.log(this.activeData);
    },
    // 点击活动系列切换
    changeActive(val, index) {
      this.selActive = index;
      if (val.label === this.$t('exhibition.allActivity')) {
        this.getexActive();
      } else {
        this.getexActive(val.label);
      }
    },
    // 展商新闻
    async getNewsinfo() {
      const upinfo = {
        exhibitorId: this.id,
        pageNo: 1,
        pageSize: 10,
      };
      const data = await getNews(upinfo);
      this.exhibNews = data.data.data.list;

      this.exhibNews.forEach((item, i) => {
          if(item.coverPhoto.indexOf("http")  == -1){
            this.exhibNews[i].coverPhoto= forMat() +   this.exhibNews[i].coverPhoto;
          }
      })

      // console.log(this.exhibNews)
    },
    // 跳转新闻详情页
    routerNews(val) {
      this.$router.push({ name: 'news_detail', params: { userId: val.id } });
    },
    // 展商资料
    async getFormations() {
      const upinfo = {
        exhibitorId: this.id,
        pageNo: 1,
        pageSize: 10,
      };
      const data = await getFormation(upinfo);

      // console.log('展商下载资料信息', data);
      this.tableData = data.data.data.list;
      this.tableData.forEach((item) => {
        var num = item.size / 1024;
        item.size = Math.round(num * 100) / 100 + 'MB';
      });
      // console.log(this.tableData);

      // this.tableData = format(this.tableData)
    },
    //转化一下文件大小

    // 收藏产品
    async collectPro(item) {
      const shouDetail = {
        objId: item.id,
        flag: !item.collectStatus,
        type: 2,
      };
      const toggleStatus = item.collectStatus === true ? true : false;
      try {
        const { data } = await getShoucang(shouDetail);
        if (data.code === 200) {
          item.collectStatus = !item.collectStatus;
          if (toggleStatus === true) {
            this.$message({
              showClose: true,
              message: this.$t('common.cancelCollect'),
              type: 'error',
            });
          } else {
            this.$message({
              showClose: true,
              message: this.$t('common.successCollect'),
              type: 'success',
            });
          }
        } else {
          tools.login(3);
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 收藏直播
    async collectLive(item) {
      const shouDetail = {
        objId: item.id,
        flag: !item.collectStatus,
        type: 3,
      };
      try {
        const { data } = await getShoucang(shouDetail);
        if (data.code === 200) {
          item.collectStatus = !item.collectStatus;
          const toggleStatus = item.collectStatus === true ? true : false;
          if (toggleStatus === true) {
            this.$message({
              showClose: true,
              message: this.$t('common.successCollect'),
              type: 'success',
            });
          } else {
            this.$message({
              showClose: true,
              message: this.$t('common.cancelCollect'),
              type: 'error',
            });
          }
        } else {
          tools.login(3);
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 收藏活动
    async collectActve(item) {
      const shouDetail = {
        objId: item.id,
        flag: !item.collectStatus,
        type: 4,
      };
      try {
        const { data } = await getShoucang(shouDetail);
        if (data.code === 200) {
          item.collectStatus = !item.collectStatus;
          const toggleStatus = item.collectStatus === true ? true : false;
          if (toggleStatus === true) {
            this.$message({
              showClose: true,
              message: this.$t('common.successCollect'),
              type: 'success',
            });
          } else {
            this.$message({
              showClose: true,
              message: this.$t('common.cancelCollect'),
              type: 'error',
            });
          }
        } else {
          tools.login(3);
        }
      } catch (err) {
        console.log(err);
      }
    },
    consult(item) {
      //咨询展商
      tools.login(1, item.id);
    },
    enters() {
      this.exhiflag = false;
    },
    leaver() {
      this.exhiflag = true;
    },
    activeDetail(item) {
      //点击每个直播盒子进入
      this.$router.push({ path: '/active_detail', query: { id: item.id } });
    },
    //点击标题开启弹框
    openDiag() {
      this.exhiflag = true;
    },
    close() {
      this.exhiflag = false;
    },
    jumping(url) {
      // console.log('跳转了');
      if (url.slice(0, 4) == 'http') {
        window.open(url1);
      } else {
        let url1 = 'http://' + url;
        // window.location.href=url1;//当前标签页
        window.open(url1); //打开一个新的标签页
      }
    },
    //--------------------------------------------------------
    //递名片功能接口
    async sendCards() {
      //判断观众是登录,未登陆提示用户进行登录
      const viewToken = localStorage.getItem('viewToken');
      if (!viewToken) {
        this.$message({ message: '请登录观众账号后操作！', type: 'warning' });
        return false;
      }
      const exId = this.exForm.id;
      let audienceUserInfo = JSON.parse(localStorage.getItem('audienceInfo')); //从localStorage中取出数据
      let CardsData = this.sendCardsData;
      const UserInfo = this.getAudience(audienceUserInfo, CardsData, exId);
      let flag = true;
      flag = this.verify(UserInfo);
      if (!flag) {
        this.$message({ message: '您的个人信息不完善,请完善个人信息后操作！', type: 'warning' });
        return false;
      }
      let data = await sendCards(UserInfo);
      console.log('递名片返回的信息是:', data);
      if (data.data.code == 200) {
        this.$message('名片递交成功!');
      }
    },
    //获取观众信息
    getAudience(audience, sendCards, exId) {
      let audienceInfo = { ...audience };
      let sendCardsData = { ...sendCards };
      let exhibitorId = exId;
      sendCardsData.hzId = exhibitorId; //展商id
      sendCardsData.auId = audienceInfo.id; //观众ID
      sendCardsData.auName = audienceInfo.name; //观众姓名
      sendCardsData.auCompany = audienceInfo.company; //观众单位
      sendCardsData.auDept = audienceInfo.dept; //观众部门
      sendCardsData.auDuty = audienceInfo.duty; //观众职务
      sendCardsData.auPhone = audienceInfo.registAccount; //观众手机号
      sendCardsData.auEmail = audienceInfo.email; //观众email
      sendCardsData.auCall = audienceInfo.named; //观众称呼【先生，女士】
      return sendCardsData;
    },
    //验证递名片的信息是否有未填写的
    verify(obj) {
      for (var key in obj) {
        if (!obj[key]) {
          return false;
        }
      }
      return true;
    },

    routerLink(flag) {
      let routerUrl;
      if (flag == 'vr') {
        routerUrl = this.testBaseDomain + 'exhibitor/' + this.id + '/index?slanguage=' + this.lang
      }
      if (flag == 'imgView') {
        routerUrl = this.testBaseDomain + 'exhibitor/' + this.id + '/index?pop=photo&slanguage=' + this.lang
      }
      if (flag == 'videoView') {
        routerUrl = this.testBaseDomain + 'exhibitor/' + this.id + '/index?pop=video&slanguage=' + this.lang;
      }
      window.open(routerUrl)
    },
  },
};
</script>
<style lang="scss" scoped>
.buttonText {
  cursor: pointer;
}

.container {
  width: 100%;
  //    height: 2010px;
  margin-top: 120px;

  h3 {
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    margin-bottom: 28px;
    color: #006fb8;
    width: 152px;
    border-left: 3px solid #006fb8;
    border-right: 3px solid #006fb8;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 30px;
  }

  ul li {
    text-decoration: none;
    list-style-type: none;
  }

  .content {
    width: 1270px;
    margin: 0 auto;
    // border: 1px solid red;
    //公司介绍
    .active_detail {
      margin-top: 45px;
      // height: 436px;
      height: auto;
      display: flex;

      .active_img {
        width: 694px;
        height: 400px;
        // border: 1px solid red;
        margin-right: 80px;
        text-align: center;
        border: 1px solid #e0e0e0;

        .img_box {
          height: 335px;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            max-width: 100%;
            margin: auto;
            max-height: 100%;
          }
        }

        .option {
          width: 694px;
          height: 65px;
          // border: 1px solid red;
          display: flex;
          align-items: center;
          justify-content: space-around;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          background: rgba(0, 111, 184, 0.2);
          color: #000000;

          img {
            vertical-align: middle;
          }

          .vr {
            position: relative;
            cursor: pointer;

            ul {
              position: absolute;
              display: none;
              background: #ffffff;
              box-shadow: 0px 0px 51px 0px #e8ecf0;
              //top: 35px;

              li {
                width: 166px;
                height: 40px;
                line-height: 40px;
                // border: 1px solid red;
              }

              li:hover {
                background: #ededed;
                color: #006fb8;
              }
            }

            &:hover {
              ul {
                display: block;
              }
            }
          }

          .picture {
            position: relative;
            cursor: pointer;

            ul {
              position: absolute;
              display: none;
              background: #ffffff;
              box-shadow: 0px 0px 51px 0px #e8ecf0;
              //top: 35px;

              li {
                width: 166px;
                height: 40px;
                line-height: 40px;
                // border: 1px solid red;
              }

              li:hover {
                background: #ededed;
                color: #006fb8;
              }
            }

            &:hover {
              ul {
                display: block;
              }
            }
          }

          .vedio {
            position: relative;
            cursor: pointer;
            ul {
              position: absolute;
              display: none;
              background: #ffffff;
              box-shadow: 0px 0px 51px 0px #e8ecf0;
              //top: 35px;

              li {
                width: 166px;
                height: 40px;
                line-height: 40px;
                // border: 1px solid red;
              }

              li:hover {
                background: #ededed;
                color: #006fb8;
              }
            }

            &:hover {
              ul {
                display: block;
              }
            }
          }
        }
      }

      .active_content {
        width: 496px;
        height: auto;
        // height: 400px;
        padding-top: 10px;

        .title {
          width: 482px;
          font-size: 29px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          line-height: 37px;
          margin-bottom: 20px;
          cursor: pointer;
        }

        .title::after {
          content: ''; // 必须
          display: block;
          width: 245px;
          margin-top: 20px;
          height: 3px;
          background-color: #006fb8;
        }

        .active_time {
          position: relative;
          .all_time {
            // display: none;
            .time {
              width: 260px;
              // display: none;
              p {
                margin-top: 20px;
                font-size: 18px;

                img {
                  vertical-align: middle;
                }

                span {
                  font-size: 18px;
                  color: #fdd000;
                  margin-right: 5px;
                }
              }
            }
          }

          .exhidetail {
            position: absolute;
            border: 1px solid #e0e0e0;
            display: flex;
            width: 521px;
            z-index: 999;
            top: 0;
            background: #ffffff;
            padding: 0 0px 20px;
            box-shadow: 0px 0px 51px 0px #dbdcdd;
            p {
              margin-top: 18px;
            }

            .close {
              width: 20px;
              height: 20px;
              position: absolute;
              right: 13px;
              top: 7px;
              img {
                width: 100%;
                height: 100%;
              }
            }

            .img_box {
              width: 110px;
              img {
                width: 100%;
                margin-top: 18px;
              }
            }

            .address {
              margin-left: 20px;
              width: 367px;
              .address_detail {
                display: flex;
                // align-items: center;
                p:first-child {
                  width: 100px;
                  // border: 1px solid red;
                }
                .jumping {
                  cursor: pointer;
                }
                .jumping:hover {
                  color: blue;
                }

                p:last-child {
                  width: 340px;
                  text-overflow: ellipsis;
                  // white-space: nowrap;
                  // overflow: hidden;
                }
              }
            }
          }

          .collent {
            .shoucang {
              border: none;
              width: 162px;
              height: 54px;
              background: #fdd000;
              border-radius: 4px;
              color: white;
              font-size: 18px;
              margin: 22px 0 0 50px;
              z-index: 9;
            }
          }
        }

        .exhibitor {
          width: 489px;
          height: 136px;
          display: flex;
          margin-top: 51px;
          border: 1px solid #e0e0e0;

          .logo {
            width: 237px;
            height: 136px;
            padding: 0 56px;
            box-sizing: border-box;
            border: 1px solid #e0e0e0;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .exhi_title {
            box-sizing: border-box;
            padding-left: 20px;

            p {
              margin-top: 20px;
            }
          }
        }

        .collent_btn {
          width: 510px;
          button {
            cursor: pointer;
          }
          .shoucang {
            border: none;
            width: 162px;
            height: 54px;
            background: #006fb8;
            border-radius: 4px;
            color: white;
            font-size: 18px;
            margin: 18px 10px 0 0;
            z-index: 9;
            &:hover {
              background: #338cc6;
            }
            &:active {
              background: #0064a6;
            }
          }

          .shoucang2 {
            border: none;
            width: 162px;
            height: 54px;
            background: #fdd000;
            border-radius: 4px;
            /*      color: white; */
            color: #006fb8;
            font-size: 18px;
            margin-top: 20px;
            //   margin: 22px 0 0 50px;
            &:hover {
              background: #fdd933;
            }
            &:active {
              background: #e4bb00;
            }
          }

          .shoucang3 {
            background: #ededed;
            border: none;
            margin-top: 20px;
            width: 162px;
            height: 54px;
            border-radius: 4px;
            color: white;
            font-size: 18px;
            &:hover {
              background: #ededed;
            }
          }

          .lastbutton {
            border: 1px solid #006fb8;
            padding: 0 5px;
            box-sizing: border-box;
            height: 54px;
            background: white;
            border-radius: 4px;
            color: #006fb8;
            font-size: 18px;
            margin-left: 10px;
            &:hover {
              background: #e6f1f8;
            }
            &:active {
              border: 1px solid #338cc6;
            }
          }
        }
      }
    }

    // 展商介绍
    .exhitbi_inc {
      margin-top: 72px;

      .vedio {
        width: 800px;
        height: 450px;
        margin: 0 auto;
        margin-top: 42px;
        // border: 1px solid red;
      }

      .shipin {
        width: 100%;
        height: 450px;
      }
    }

    //产品中心
    .product {
      margin-top: 110px;

      .product_box {
        display: flex;

        .list {
          width: 295px;
          height: 330px;
          //   border: 1px solid red;
          p:first-child {
            width: 295px;
            height: 50px;
            background: #006fb8;
            line-height: 50px;
            color: white;
            text-decoration: none;
            padding-left: 20px;
            box-sizing: border-box;
          }

          .allClick {
            color: #006fb8;
          }

          ul {
            margin: 17px 0 0px;
          }

          .leftItem:hover {
            background: #e4e7ed;
          }

          .leftItem {
            width: 295px;
            height: 40px;
            //line-height: 30px;
            line-height: 40px;
            box-sizing: border-box;
            padding-left: 20px;
            position: relative;
            cursor: pointer;
            display: block;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            //display: flex;
            //align-items: center;
          }
        }

        .right {
          //   width: 945px;
          display: flex;
          flex-wrap: wrap;

          .rightBox {
            width: 293px;
            height: min-content;
            border: 1px solid #e0e0e0;
            margin-left: 30px;
            margin-bottom: 30px;
            cursor: pointer;
            &:hover {
              box-shadow: 0px 0px 51px 0px #e8ecf0;
            }

            .parameter {
              height: 158px;
              padding-top: 35px;
              box-sizing: border-box;
              .titl {
                color: #333333;
                font-size: 24px;
                line-height: 28px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                //margin-top: 35px;
                margin-left: 24px;
                max-width: 247px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                word-break: break-all;
              }

              .english {
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #333333;
                margin-top: 15px;
                margin-left: 22px;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
                max-width: 247px;
              }

              .txt {
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #999999;
                margin-top: 10px;
                margin-left: 23px;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
                max-width: 247px;
              }
            }

            .backImg {
              width: 247px;
              height: 185px;
              //margin: 35px 0px 0px 24px;
              margin: 0 auto 5px;
              justify-content: center;
              align-items: center;
              display: flex;
              img {
                max-width: 100%;
                max-height: 100%;
                vertical-align: middle;
              }
            }

            .companyName {
              margin: 19px 24px 20px 24px;
              display: flex;
              justify-content: flex-start;
              align-items: center;

              .leftTitle {
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #999999;
                width: 203px;
                text-overflow: ellipsis;
                white-space: nowrap;
                max-width: 203px;
                overflow: hidden;
                text-overflow: ellipsis;
              }

              .rightIcon {
                width: 18px;
                height: 18px;
                margin-left: 6px;

                img {
                  width: 100%;
                  height: 100%;
                }
              }
            }

            .boxBottom {
              height: 68px;
              width: 295px;
              border-radius: 1px;
              border-top: 1px solid #e0e0e0;
              display: flex;
              justify-content: space-between;
              align-items: center;

              .bottomTxt {
                margin-left: 24px;

                a {
                  text-decoration: none;
                  font-size: 16px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #006fb8;
                }
              }

              .bottomImg {
                width: 30px;
                height: 28px;
                margin-right: 24px;

                img {
                  width: 100%;
                  height: 100%;
                }
              }
            }
          }

          //right结束
        }

        .more {
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          margin-left: 291px;
          width: 100px;
          height: 23px;

          .icon_more {
            display: inline-block;
            vertical-align: middle;
            width: 0;
            height: 0;
            border: 6px solid transparent; /*5px 足够了*/
            border-top-color: #818895; /*top箭头向下 bottom箭头向上*/
            margin-left: 15px;
          }

          .icon_more:hover {
            cursor: pointer;
          }
        }
      }
    }

    //展商直播
    .live {
      margin-top: 110px;
      margin-bottom: 70px;

      .live-box {
        display: flex;
        width: 1312px;
        //   height: 1500px;
        //   border: 1px solid red;
        flex-wrap: wrap;
        justify-content: flex-start;

        .item {
          width: 295px;
          height: 295px;
          border: 1px solid #e0e0e0;
          margin-right: 31px;
          box-shadow: 0px 0px 51px 0px #e8ecf0;
          /*   margin-top: 31px;
 */
          .vedio {
            width: 295px;
            height: 166px;
            margin-bottom: 20px;
            // border: 1px yellow solid;
            position: relative;

            .shoucang {
              position: absolute;
              top: 10px;
              right: 10px;
              width: 30px;
              height: 30px;
              z-index: 9;
            }

            .zhibopic {
              width: 100%;
              height: 100%;
            }

            .fixed {
              width: 100%;
              height: 100%;
              position: absolute;
              top: 0;
              background-color: rgba(30, 30, 30, 0.3);
              display: none;

              img {
                margin: 65px 118px 53px 129px;
              }
            }
          }

          .vedio:hover > .fixed {
            display: block;
          }

          .title {
            box-sizing: border-box;
            height: 98px;
            padding: 0px 35px 0 23px;

            p {
              font-size: 18px;
              line-height: 24px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              word-break: break-all;
            }

            .ptime {
              /*  color: #fdd000; */
              color: #666666;
              font-size: 16px;
              display: flex;
              justify-content: flex-start;
              align-items: center;
              margin-top: 12px;

              img {
                width: 19px;
                height: 19px;
                margin-right: 9px;
              }
            }
          }

          .down {
            border-top: 1px #e0e0e0 solid;
            height: 60px;

            p {
              font-size: 16px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              line-height: 60px;
              margin-left: 20px;
              color: #999999;
            }
          }
        }
      }
    }

    //展商活动
    .exhibitor_active {
      margin-top: 70px;
      margin-bottom: 112px;

      .active_box {
        display: flex;
        color: #999;

        .list {
          width: 295px;
          height: 330px;
          //   border: 1px solid red;
          p:first-child {
            width: 295px;
            height: 50px;
            background: #006fb8;
            line-height: 50px;
            color: white;
            text-decoration: none;
            padding-left: 20px;
            box-sizing: border-box;
          }

          .allClick {
            color: #006fb8;
          }

          ul {
            margin: 17px 0 0px;
          }

          .leftItem:hover {
            background: #e4e7ed;
          }

          .leftItem {
            width: 295px;
            height: 40px;
            //line-height: 30px;
            line-height: 40px;
            box-sizing: border-box;
            padding-left: 20px;
            position: relative;
            cursor: pointer;
            //display: flex;
            //align-items: center;
            display: block;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
        }

        .right {
          display: flex;
          flex-wrap: wrap;
          // margin-left: 25px;
          .item {
            width: 294px;
            height: 354px;
            // margin-top: 20px;
            margin-left: 29px;
            border: 1px solid #e0e0e0;
            margin-bottom: 30px;
            .vedio {
              width: 295px;
              height: 197px;
              margin-bottom: 20px;
              // border: 1px yellow solid;
              position: relative;
              background: #161c3f;

              .shoucang {
                position: absolute;
                z-index: 9;
                top: 10px;
                right: 10px;
                width: 30px;
                height: 30px;
              }

              .vedio_picture {
                width: 100%;
                height: 166px;
              }
            }

            .title {
              box-sizing: border-box;
              height: 117px;
              padding: 0px 35px 50px 24px;

              p {
                margin-top: 5px;
                font-size: 18px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                word-break: break-all;
              }

              .acttime {
                color: #fdd000;
                font-size: 16px;

                img {
                  width: 19px;
                  height: 19px;
                  margin-right: 8px;
                }
              }

              .zhanwei {
                font-size: 16px;
                color: #666666;
                img {
                  width: 20px;
                  height: 22px;
                  margin-right: 8px;
                }
              }
            }
          }
        }
      }
    }

    //展商新闻
    .exhibitor_news {
      margin-top: 65px;
      h3 {
        margin-bottom: 28px;
      }

      .news_box {
        width: 1270px;
        height: 199px;
        border: 1px solid #e0e0e0;
        box-shadow: 0px 0px 29px 0px #e8ecf0;
        display: flex;
        margin-bottom: 30px;
        cursor: pointer;
        .news_pricture {
          width: 295px;
          height: 197px;
          padding-top: 10px;
          padding-left: 10px;
          // border: 1px solid red;
          img {
            width: 90%;
            height: 90%;
          }
        }

        .news_content {
          width: 974px;

          .title {
            font-size: 24px;
            color: #006fb8;
            font-family: Microsoft YaHei;
            font-weight: 400;
            margin: 43px 0 19px 42px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            max-width: 900px;
          }

          .content1 {
            width: 905px;
            margin-left: 41px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
            line-height: 21px;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }

          .daytime {
            margin-top: 20px;
          }
        }
      }
    }

    //展商资料
    .exhib_data {
      margin: 71px 0 70px;
    }
  }
}
</style>
<style scoped>
.leftItem:hover::before {
  box-sizing: border-box;
  width: 4px;
  height: 40px;
  background-color: gold;
  content: '';
  position: absolute;
  top: 0px;
  left: 0px;
}
</style>